import React from "react";
import Grid from "@mui/material/Grid2";
import MobileStyles from "../MobileStyles";
import WebStyles from "../WebStyles";
import { TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const EmailIDField = (props) => {
  const selector = useSelector((data) => data?.mobileReducer);
  const isMobile = selector?.ismobile;
  const classes = isMobile ? MobileStyles() : WebStyles();
  const {
    editableBeneDetails,
    SelectedBeneDetails,
    isEditable,
    flag,
    handleInputChange,
    handleEditChange,
  } = props;

  return (
    <Grid size={{ xs: 12, md: 6 }} className={classes.spacing}>
      <Typography variant="body2" className={classes.headerstyle}>
        Email ID
      </Typography>
      {isEditable ? (
        <TextField
          variant="outlined"
          size="small"
          value={editableBeneDetails?.EmailID}
          onChange={handleInputChange}
          onBlur={handleEditChange}
          name="EmailID"
        />
      ) : editableBeneDetails?.EmailID ? (
        <span className={classes.contentstyle}>
          {editableBeneDetails?.EmailID}
        </span>
      ) : SelectedBeneDetails?.EmailID ? (
        <span className={classes.contentstyle}>
          {SelectedBeneDetails?.EmailID}
        </span>
      ) : (
        "---"
      )}
      {flag && editableBeneDetails?.IsEmailIDURL && (
        <img
          src={editableBeneDetails?.IsEmailIDURL}
          alt="checkmark"
          className={classes.checkMark}
        />
      )}
    </Grid>
  );
};

export default EmailIDField;
